import { render, staticRenderFns } from "./contentRecord.vue?vue&type=template&id=d2e9e560&scoped=true&"
import script from "./contentRecord.vue?vue&type=script&lang=js&"
export * from "./contentRecord.vue?vue&type=script&lang=js&"
import style0 from "./contentRecord.vue?vue&type=style&index=0&id=d2e9e560&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e9e560",
  null
  
)

export default component.exports